import api from './config';

/**
 * Get the number of unread notifications for the current user
 * @returns {Promise<number>} The number of unread notifications
 */
export const getUnreadNotificationCount = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }

    const response = await api.get('/notification/unread/count', {
      headers: {
        'Authorization': `Bearer ${atob(token)}`,
      },
    });
    return response.data.count;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get paginated notifications for the current user
 * @param {number} page The page number (0-based)
 * @param {number} size The page size
 * @returns {Promise<Object>} The paginated notifications response
 */
export const getNotifications = async (page = 0, size = 10) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }

    const response = await api.get('/notification', {
      params: {
        page,
        size,
      },
      headers: {
        'Authorization': `Bearer ${atob(token)}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Mark a notification as read
 * @param {string} notificationId The ID of the notification to mark as read
 * @returns {Promise<void>}
 */
export const markNotificationAsRead = async (notificationId) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }

    await api.post(`/notification/${notificationId}/read`, null, {
      headers: {
        'Authorization': `Bearer ${atob(token)}`,
      },
    });
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Mark all notifications as read
 * @returns {Promise<void>}
 */
export const markAllNotificationsAsRead = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }

    await api.post('/notification/read-all', null, {
      headers: {
        'Authorization': `Bearer ${atob(token)}`,
      },
    });
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 